import styled from 'styled-components';

export default styled.form`
  display: flex;
  align-items: center;
  flex-direction: column;
`;
